import apiRequestActionCreator from './apiRequestActionCreator';

export const uploadLocationInfoAttachment = ({ apmId, id, formData }) =>
    apiRequestActionCreator({
        actionName: 'APM_LOCATION_INFO_ATTACHMENT_UPLOAD',
        params: {
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            method: 'post',
            url: `apms/${apmId}/location-info/${id}/attachment`,
        },
    });

export const deleteLocationInfoAttachment = ({ apmId, id, attachmentId }) =>
    apiRequestActionCreator({
        actionName: 'APM_LOCATION_INFO_ATTACHMENT_DELETE',
        params: {
            method: 'delete',
            url: `apms/${apmId}/location-info/${id}/attachment/${attachmentId}`,
        },
    });
